const HISTORY_DATATABLE_FOOTER_HEIGHT = 53;
export default HISTORY_DATATABLE_FOOTER_HEIGHT;
